import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import includes from 'lodash/includes';
import keys from 'lodash/keys';
import filter from 'lodash/filter';
import size from 'lodash/size';

import { CARE_ROLE } from '../../../constants/props';

const PICKED_ROLES = [
  CARE_ROLE.GUARDIAN,
  CARE_ROLE.CAREGIVER,
  CARE_ROLE.PROXY,
  CARE_ROLE.PARENT,
];

export default (options, initialData) => {
  const selectedRoles = pick(initialData, PICKED_ROLES);
  const selectedPositive = pickBy(selectedRoles, item => item === true);
  const selectedKeys = keys(selectedPositive);
  const filteredOptions = filter(
    options,
    item => !includes(selectedKeys, item.value),
  );

  if (!size(selectedKeys)) {
    return filter(
      filteredOptions,
      item => item.value !== CARE_ROLE.FAMILY_MEMBER,
    );
  }

  return filteredOptions;
};



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/utils/handleRolesOptions.js